export { default } from './RubberReceivableCreateAndUpdateModal'
